import React from 'react';
import {useDispatch} from 'react-redux';
import {SidePanelContent} from '../../store/actions/types/grid.types';
import {setSidePanelContentAction} from '../../store/actions/grid';
import {SLIDE_WORKSPACE_DESKTOP} from '../../ui/pages/PresEditPage/components/slideContainer/SlideContainer';
import {SLIDE_CONTAINER_WRAPPER} from '../../ui/pages/PresEditPage/components/slideContainer/SlidesContainerWrapper';
import {SLIDE_WORKSPACE_MOBILE} from '../../ui/pages/PresEditPage/components/slideContainer/SlideContainerMobile';

type targetIdType = typeof SLIDE_WORKSPACE_DESKTOP | typeof SLIDE_CONTAINER_WRAPPER | typeof SLIDE_WORKSPACE_MOBILE;

export const useSlideClickHandler = (): ((event: React.MouseEvent<HTMLDivElement>, targetId: targetIdType, isGrid?: boolean) => void) => {
    const dispatch = useDispatch();

    return (event: React.MouseEvent<HTMLDivElement>, targetId: targetIdType, isGrid?: boolean): void => {
        const target = event.target as HTMLElement;

        if (target.id === targetId || isGrid) {
            dispatch(setSidePanelContentAction(SidePanelContent.SLIDE));
        }
    };
};
